import React, { useContext, useEffect } from "react";
import { Context as ReviewsContext } from "../../context/ReviewsContext";
import SortingTable from "../../components/SortingTable";
import Indicators from "./Indicators";

const headCells = [
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Email",
  },
  {
    id: "message",
    numeric: false,
    disablePadding: true,
    label: "Comentario",
  },
  { id: "service", numeric: true, disablePadding: false, label: "Servicio" },
  { id: "quality", numeric: true, disablePadding: false, label: "Calidad" },
  {
    id: "cleanliness",
    numeric: true,
    disablePadding: false,
    label: "Limpieza",
  },
];

const Reviews = ({history}) => {
  const {
    state: { reviews },
    fetchReviews,
    fetchIndicators,
  } = useContext(ReviewsContext);


  useEffect(() => {
    fetchReviews();
    fetchIndicators();
    // eslint-disable-next-line
  }, []);

  const rows = reviews.map((review) => {
    return {
      id: review.id,
      email: review.email,
      message: review.message,
      service: review.serviceScore,
      quality: review.qualityScore,
      cleanliness: review.cleanlinessScore,
    };
  });

  const handleRowSelect = (event, id) => {
    history.push(`/reviews/${id}`)
  }

  return (
    <div>
      <Indicators/>
      <SortingTable headCells={headCells} rows={rows} title="Respuestas" handleRowClick={handleRowSelect} />
    </div>
  );
};
export default Reviews;
